// @flow
import * as Immutable from 'immutable'; // This is required
import ImmutableModel from './ImmutableModel'; // Make sure you copied this file into your repo

type UserHeaderDataTypeEnum =
    | 'STRING'
    | 'WHOLE_NUM'
    | 'DECIMAL_NUMBER'
    | 'NON_NEGATIVE_DECIMAL_NUMBER'
    | 'POSITIVE_INTEGER';

type TaskProfileUseCaseEnum =
    | 'PICKUP_DELIVERY'
    | 'DELIVERY_FROM_HOMEBASE'
    | 'SERVICE';

export type TaskProfileModelType = {
    clientId: string,
    teamId: ?string,
    taskProfileId: string,
    csvParserSettings: ParserSettingsModelType
};

export type ParserSettingsModelType = {
    useCase: TaskProfileUseCaseEnum,
    userHeaders: { [key: string]: UserHeaderModelType }
};

export type UserHeaderModelType = {
    dataType: UserHeaderDataTypeEnum,
    editable: boolean
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class TaskProfile extends ImmutableModel {
    static fromJS(json: TaskProfileModelType): TaskProfile {
        const state: Object = Object.assign({}, json);
        state.csvParserSettings = ParserSettings.fromJS(
            state.csvParserSettings
        );
        return new this(Immutable.Map(state));
    }

    toJS(): TaskProfileModelType {
        return {
            clientId: this.clientId,
            teamId: this.teamId,
            taskProfileId: this.taskProfileId,
            csvParserSettings: this.csvParserSettings.toJS()
        };
    }

    get clientId(): string {
        return this._state.get('clientId');
    }

    setClientId(clientId: string): this {
        return this.clone(this._state.set('clientId', clientId));
    }

    get teamId(): ?string {
        return this._state.get('teamId');
    }

    setTeamId(teamId: ?string): this {
        return this.clone(this._state.set('teamId', teamId));
    }

    get taskProfileId(): string {
        return this._state.get('taskProfileId');
    }

    setTaskProfileId(taskProfileId: string): this {
        return this.clone(this._state.set('taskProfileId', taskProfileId));
    }

    get csvParserSettings(): ParserSettings {
        return this._state.get('csvParserSettings');
    }

    setCsvParserSettings(csvParserSettings: ParserSettings): this {
        return this.clone(
            this._state.set('csvParserSettings', csvParserSettings)
        );
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class ParserSettings extends ImmutableModel {
    static fromJS(json: ParserSettingsModelType): ParserSettings {
        const state: Object = Object.assign({}, json);
        state.userHeaders = Immutable.Map(state.userHeaders).map(item =>
            UserHeader.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }

    toJS(): ParserSettingsModelType {
        return {
            useCase: this.useCase,
            userHeaders: this.userHeaders.map(item => item.toJS()).toObject()
        };
    }

    get useCase(): TaskProfileUseCaseEnum {
        return this._state.get('useCase');
    }

    setUseCase(useCase: TaskProfileUseCaseEnum): this {
        return this.clone(this._state.set('useCase', useCase));
    }

    get userHeaders(): Immutable.Map<string, UserHeader> {
        return this._state.get('userHeaders');
    }

    setUserHeaders(userHeaders: Immutable.Map<string, UserHeader>): this {
        return this.clone(this._state.set('userHeaders', userHeaders));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class UserHeader extends ImmutableModel {
    static fromJS(json: UserHeaderModelType): UserHeader {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    toJS(): UserHeaderModelType {
        return {
            dataType: this.dataType,
            editable: this.editable
        };
    }

    get dataType(): UserHeaderDataTypeEnum {
        return this._state.get('dataType');
    }

    setDataType(dataType: UserHeaderDataTypeEnum): this {
        return this.clone(this._state.set('dataType', dataType));
    }

    get editable(): boolean {
        return this._state.get('editable');
    }

    setEditable(editable: boolean): this {
        return this.clone(this._state.set('editable', editable));
    }
}
